import React, { Component } from 'react'
import { Routes, Route } from 'react-router-dom'

import './App.css'
//import PsnList from './Components/PsnListing'
import CompHeader from './Components/CompHeader'
import CompFooter from './Components/CompFooter'
import CompHome from './Components/CompHome'
import CompGames from './Components/CompGames'
class App extends Component {
  constructor(props) {
    super(props)

    this.state = {
        location: ""
    }
  }
  
  render () {
    return (
      <div className="App">
        <CompHeader />

        <Routes>
          <Route path="/">
            <Route index element={<CompHome />} />
            <Route path=":url" element={<CompGames />} />
          </Route>
        </Routes>

        <CompFooter />

      </div>
    )
  }
}

export default App
